import { render, staticRenderFns } from "./SelectGender.vue?vue&type=template&id=1ff81c90&scoped=true&"
import script from "./SelectGender.vue?vue&type=script&lang=js&"
export * from "./SelectGender.vue?vue&type=script&lang=js&"
import style0 from "./SelectGender.vue?vue&type=style&index=0&id=1ff81c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff81c90",
  null
  
)

export default component.exports